import Vue from 'vue'
import Vuex from 'vuex'
import { CLOSE_NEW_LINE, CHANGE_WINDOW_WIDTH, TOGGLE_LOADING, } from './mutations-types'
import { search, } from './modules/search'
import { auth, } from './modules/auth'
import { record, } from './modules/record'
import { credential, } from './modules/credential'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    showNewLine: true,
    windowWidth: window.innerWidth,
    loading: false,
  },
  mutations: {
    [CLOSE_NEW_LINE] (state) {
      state.showNewLine = false
    },
    [CHANGE_WINDOW_WIDTH] (state, payload) {
      state.windowWidth = payload
    },
    [TOGGLE_LOADING] (state, payload) {
      state.loading = payload
    },
  },
  actions: {},
  getters: {
    screenWidth (state) {
      return state.windowWidth
    },
    isMobileScreen (state) {
      return state.windowWidth <= 768
    },
  },
  modules: {
    search,
    record,
    auth,
    credential,
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js